import JSONFormatter from "json-formatter-js";

// Просмотр сводных параметров расчёта в модальном окне: объект приезжает в data-атрибуте
// кнопки, отдельный запрос за ним не нужен — расчётов на заказе единицы.
export const SummaryViewer = () => {
	$(document).ready(() => {
		document
			.querySelectorAll(".summary-viewer-button")
			.forEach(setupSummaryButton);
	});
};

const setupSummaryButton = (button) => {
	button.addEventListener("click", () => {
		openSummaryDialog(JSON.parse(button.dataset.summary));
	});
};

// Раскрываем дерево на два уровня: глубже объект со вложенной actual_run.summary
// превращается в простыню
const OPEN_DEPTH = 2;

const openSummaryDialog = (summary) => {
	const dialog = document.createElement("dialog");
	dialog.className = "summary-viewer-dialog";

	const closeButton = document.createElement("button");
	closeButton.type = "button";
	closeButton.className = "summary-viewer-close";
	closeButton.textContent = "×";
	closeButton.addEventListener("click", () => dialog.close());

	const content = document.createElement("div");
	content.className = "summary-viewer-content";
	content.appendChild(new JSONFormatter(summary, OPEN_DEPTH).render());

	dialog.append(closeButton, content);
	// щелчок вне окна приходит на сам dialog: его область — это backdrop
	dialog.addEventListener("click", (event) => {
		if (event.target === dialog) dialog.close();
	});
	// окно одноразовое: закрытие по кнопке, Escape или backdrop убирает его из DOM
	dialog.addEventListener("close", () => dialog.remove());

	document.body.appendChild(dialog);
	dialog.showModal();
};
